export const BLOCKED_CONVERSATION_STATUS = 'blocked';
export const OPEN_CONVERSATION_STATUS = 'open';
export const ARCHIVED_CONVERSATION_STATUS = 'archived';

export type TConversationListFilter = 'active' | 'archived';

export const getConversationListFilters = (
    filter: TConversationListFilter
): { filters: Record<string, unknown> } => {
    if (filter === 'archived') {
        return { filters: { status: ARCHIVED_CONVERSATION_STATUS } };
    }

    return { filters: { status: { $ne: ARCHIVED_CONVERSATION_STATUS } } };
};

export const buildOmnichannelConversationsQuery = (
    filter: TConversationListFilter,
    overrides: {
        page?: number;
        limit?: number;
        sort?: string;
        filters?: Record<string, unknown>;
    } = {}
) => {
    const { filters: overrideFilters, ...restOverrides } = overrides;

    return {
        page: 1,
        limit: 20,
        sort: '-lastMessageAt',
        ...restOverrides,
        filters: {
            ...getConversationListFilters(filter).filters,
            ...overrideFilters,
        },
    };
};
